(function(){
  var bar = document.getElementById('stickyBar');
  var closeBtn = document.getElementById('stickyClose');
  var threshold = 600;
  var dismissed = false;

  function onScroll(){
    if(dismissed) return;
    if(window.scrollY > threshold){ bar.classList.add('show'); } else { bar.classList.remove('show'); }
  }

  closeBtn.addEventListener('click', function(){
    dismissed = true;
    bar.classList.remove('show');
  });

  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();
})();

(function(){
  if(window.innerWidth < 821) return;
  if(window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return;
  try { if(sessionStorage.getItem('steadyExitShown')) return; } catch(e){}

  var modal = document.getElementById('exitModal');
  var overlay = document.getElementById('exitOverlay');
  var closeBtn = document.getElementById('exitClose');
  var declineBtn = document.getElementById('exitDecline');
  var ctaBtn = document.getElementById('exitCta');

  var armed = false;
  var minDwellMs = 6000;
  var minScroll = 300;

  setTimeout(function(){
    if(window.scrollY > minScroll) armed = true;
    window.addEventListener('scroll', function once(){
      if(window.scrollY > minScroll){ armed = true; window.removeEventListener('scroll', once); }
    }, {passive:true});
  }, minDwellMs);

  function show(){
    if(!armed) return;
    try { if(sessionStorage.getItem('steadyExitShown')) return; } catch(e){}
    try { sessionStorage.setItem('steadyExitShown','1'); } catch(e){}
    modal.classList.add('show');
    overlay.classList.add('show');
    modal.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
  }

  function hide(){
    modal.classList.remove('show');
    overlay.classList.remove('show');
    modal.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  }

  document.addEventListener('mouseleave', function(e){
    if(e.clientY <= 0 && (e.relatedTarget === null || e.relatedTarget === undefined)){ show(); }
  });

  closeBtn.addEventListener('click', hide);
  declineBtn.addEventListener('click', hide);
  overlay.addEventListener('click', hide);
  ctaBtn.addEventListener('click', hide);

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') hide();
  });
})();
;(function(){document.documentElement.classList.add('amie-static-rendered');})();
